//대시보드
import React, { useState, useEffect, useCallback } from "react";
import styled from "styled-components";
import { useNavigate } from "react-router-dom";
import { palette } from "../../../../assets/styles/Palette";
import { Body2, Sub2, Body3 } from "../../../../assets/styles/Typography";
import { Button } from "../../../../assets/styles/ButtonStyle";
import MoleculeHeader from "../../../Global/components/molecules/MoleculeHeader";
import { useAtom } from "jotai";
import class_one_img from "../../../../assets/images/Background/class_one.png";
import class_all_img from "../../../../assets/images/Background/whole_class.png";
import arrow_svg from "../../../../assets/images/arrow.svg";
import {
  IS_LOGGED_IN,
  AUTODISPLAY_SELECTED_DEVICE,
  AUTODISPLAY_DISPLAY_LIST,
  AUTODISPLAY_CONTENT_LIST,
  CUSTOMER_ID,
  CUSTOMER_NAME,
  CUSTOMER_DETAIL,
} from "../../../AtomStates";
import OrganismDashboardDisplayList from "../organisms/OrganismDashboardDisplayList";
import OrganismEduDashboardContentList from "../organisms/OrganismEduDashboardContentList";
import MoleculeContentTypeSelectPopup from "../molecules/MoleculeContentTypeSelectPopup";

import {
  getDisplayListOnServer,
  getDisplayListCustomerOnServer,
  getEduViewListOnServer,
  getEduViewListCustomerOnServer,
  getUserMemberType,
  getUserInfo,
  getCustomerDetailOnServer,
  getEduBoardDetailOnServer,
} from "../../../../utils/indexedDB";
import { TabWrapType3 } from "../../../../assets/styles/BusinessAnalysisStyle";

const TemplateEducationContentsList = ({
  onBack,
  onCreateContent,
  onCreateGeneralContent,
  onCreateMealContent,
}) => {
  const navigate = useNavigate();

  // 대시보드 상태 데이터
  const [stats] = useState({
    displayList: 5,
    totalContent: 20,
    activeContent: 10,
    credits: 21250,
  });
  const [activeTab, setActiveTab] = useState("content");
  // 팝업 관련 상태
  const [isLoggedIn, setIsLoggedIn] = useAtom(IS_LOGGED_IN);
  const [selectedDevice, setSelectedDevice] = useAtom(
    AUTODISPLAY_SELECTED_DEVICE
  );
  const [customerId, setCustomerId] = useAtom(CUSTOMER_ID);
  const [customerName, setCustomerName] = useAtom(CUSTOMER_NAME);
  const [customerDetail, setCustomerDetail] = useAtom(CUSTOMER_DETAIL);
  const [isCustomizePopupOpen, setIsCustomizePopupOpen] = useState(false);
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [addDisplayForm, setAddDisplayForm] = useState({
    deviceTitle: "",
    deviceLocation: "",
    deviceTarget: "",
    deviceSpec: {
      deviceWidth: "",
      deviceHeight: "",
      deviceWidthMM: "",
      deviceHeightMM: "",
      deviceCm: "",
      deviceResolution: "",
      deviceDPI: "",
      deviceInch: "",
    },
  });
  const [activateCount, setActivateCount] = useState(0);
  const [selectBoxStates, setSelectBoxStates] = useState({
    deviceDPI: false,
    deviceInch: false,
  });
  const [showDeviceSelectPopup, setShowDeviceSelectPopup] = useState(false);
  const [isTypingDPI, setIsTypingDPI] = useState(false);
  const [isTypingInch, setIsTypingInch] = useState(false);
  const [displayList, setDisplayList] = useAtom(AUTODISPLAY_DISPLAY_LIST);
  const [contentList, setContentList] = useAtom(AUTODISPLAY_CONTENT_LIST);
  const [newDisplayId, setNewDisplayId] = useState(null);
  const [selectedEditDisplayId, setSelectedEditDisplayId] = useState(null);
  const [companyName, setCompanyName] = useState("");

  // 콘텐츠 유형 선택 팝업 상태
  const [showContentTypePopup, setShowContentTypePopup] = useState(false);

  // 고객사 정보를 불러오는 함수
  const fetchCustomerDetail = async (userMemberType) => {
    const customerIdFromStorage = sessionStorage.getItem("customerId") || "";
    setCustomerId(customerIdFromStorage);
    if (customerIdFromStorage !== "") {
      try {
        let customerDetailResponse;
        if (
          userMemberType.member_type === 31 ||
          userMemberType.member_type === 32
        ) {
          customerDetailResponse = await getEduBoardDetailOnServer(
            customerIdFromStorage,
            isLoggedIn
          );
        } else {
          customerDetailResponse = await getCustomerDetailOnServer(
            customerIdFromStorage,
            isLoggedIn
          );
        }
        if (customerDetailResponse) {
          setCustomerDetail(customerDetailResponse);
          setCompanyName(customerDetailResponse.companyName);
          console.log("customerDetailResponse", customerDetailResponse);
        }
      } catch (error) {
        console.error("고객사 정보를 불러오는 중 오류가 발생했습니다:", error);
      }
    }
  };

  useEffect(() => {
    const checkMemberType = async () => {
      const accessToken = sessionStorage.getItem("accessToken");
      const userMemberType = await getUserMemberType(accessToken);

      const lastUrl = sessionStorage.getItem("lastUrl");

      const currentUrl = window.location.href;
      sessionStorage.setItem("lastUrl", currentUrl);

      fetchCustomerDetail(userMemberType);

      if (
        (lastUrl === "/ApiDashBoard" || lastUrl === "/CreateApiContent") &&
        userMemberType.member_type === 99
      ) {
        navigate("/Admin");
      }

      if (userMemberType.member_type === 11) {
        navigate("/DashBoard");
      } else if (userMemberType.member_type === 12) {
        navigate("/CustomerManage");
      } else if (userMemberType.member_type === 21) {
        navigate("/ApiDashBoard");
      } else if (userMemberType.member_type === 22) {
        navigate("/CustomerManage");
      }
    };

    checkMemberType();
  }, []);

  // 데이터 fetching 함수 분리
  const fetchContentList = async () => {
    if (!isLoggedIn) {
      return; // 로그인 상태가 아니면 API를 호출하지 않음
    }

    try {
      let response;
      const accessToken = sessionStorage.getItem("accessToken");
      const memberType = await getUserMemberType(accessToken);
      const customerIdFromStorage = sessionStorage.getItem("customerId") || "";

      if (
        customerIdFromStorage === "" &&
        (memberType.member_type === 11 ||
          memberType.member_type === 21 ||
          memberType.member_type === 31)
      ) {
        response = await getDisplayListOnServer(10, 1, isLoggedIn);
        setDisplayList(response.data);
      } else {
        response = await getDisplayListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );
        setDisplayList(response.data);
      }

      let viewList;

      if (
        customerIdFromStorage === "" &&
        (memberType.member_type === 11 ||
          memberType.member_type === 21 ||
          memberType.member_type === 31)
      ) {
        viewList = await getEduViewListOnServer(10, 1, isLoggedIn);
        setContentList(viewList.data);
        setActivateCount(viewList.activate_count);
      } else {
        viewList = await getEduViewListCustomerOnServer(
          customerIdFromStorage,
          999,
          1,
          isLoggedIn
        );

        setContentList(viewList.data);
        setActivateCount(viewList.activate_count);
      }

      setContentList(viewList.data);
    } catch (error) {
      console.error("콘텐츠 리스트를 불러오는 중 오류가 발생했습니다:", error);
    }
  };

  const fetchCompanyName = async () => {
    const accessToken = sessionStorage.getItem("accessToken");
    // const memberType = await getUserMemberType(accessToken);
    if (customerId === "") {
      const userInfo = await getUserInfo(accessToken);
      setCustomerName(userInfo.organization_name);
    }
  };

  useEffect(() => {
    fetchContentList();
    fetchCompanyName();
  }, [isLoggedIn]);

  const handleCustomizePopupClose = () => {
    setIsCustomizePopupOpen(false);
    setActiveTabIndex(0);
    setAddDisplayForm({
      deviceTitle: "",
      deviceLocation: "",
      deviceTarget: "",
      deviceSpec: {
        deviceWidth: "",
        deviceHeight: "",
        deviceCm: "",
        deviceResolution: "",
        deviceDPI: "",
        deviceInch: "",
      },
    });
  };

  const handleCustomizePopupConfirm = () => {
    if (activeTabIndex < 2) {
      setActiveTabIndex(activeTabIndex + 1);
    } else {
      // 마지막 탭에서 확인
      // console.log("기기 등록 완료", addDisplayForm);
      handleCustomizePopupClose();
    }
  };

  const toggleSelectBox = (type) => {
    setSelectBoxStates((prev) => ({
      ...prev,
      [type]: !prev[type],
    }));
  };

  const handleFormChange = useCallback((field, value) => {
    setAddDisplayForm((prev) => ({
      ...prev,
      [field]: value,
    }));
  }, []);

  const isFormValid = () => {
    const deviceDPIValid =
      addDisplayForm.deviceDPI &&
      (addDisplayForm.deviceDPI !== "기타" || addDisplayForm.deviceInch);

    return (
      addDisplayForm.deviceTitle &&
      addDisplayForm.deviceLocation &&
      addDisplayForm.deviceTarget &&
      deviceDPIValid &&
      addDisplayForm.deviceInch &&
      addDisplayForm.deviceSpec.deviceWidth &&
      addDisplayForm.deviceSpec.deviceHeight
    );
  };

  // AutodisplaySelectedPopup에서 기기 선택 시
  const handleAutoDisplaySelect = () => {
    // const originalDevice = displayList.find((d) => d._id === selectedDisplayId);
    // console.log("originalDevice", originalDevice);
    //! 추후 수정
    const originalDevice = {
      _id: "6879e4719eec30c7d8116b30",
      createDate: "2025. 07. 18. 오후 03:06:41",
      user: "gyeongwon_admin@userconnect.kr",
      customer: "6877467b7d2ec89430c251b2",
      deviceSpec: {
        deviceWidth: "3840",
        deviceHeight: "2160",
        deviceWidthMM: "1896",
        deviceHeightMM: "1063",
        deviceCm: "218.44",
        deviceResolution: "UHD",
        deviceDPI: "(가로) UHD | 3840 × 2160",
        deviceInch: "86인치",
      },
      deviceTitle: "디지털 칠판",
      timestamp: 1752818801284,
      updateDate: "2025. 07. 18. 오후 03:06:41",
    };

    if (originalDevice) {
      setSelectedDevice(originalDevice);
      setShowDeviceSelectPopup(false);

      if (customerDetail.boardType === "general") {
        navigate("/CreateEducationContent", {
          state: { selectedDevice: originalDevice },
        });
      } else if (customerDetail.boardType === "meal") {
        navigate("/CreateEducationMeal", {
          state: { selectedDevice: originalDevice },
        });
      } else {
        navigate("/CreateEducationContent", {
          state: { selectedDevice: originalDevice },
        });
      }
    }
  };

  // const handleAutoDisplayClose = () => {
  //   setShowDeviceSelectPopup(false);
  // };

  // const handleSaveNewDisplay = async (displayData) => {
  //   try {
  //     // customerId가 있으면 displayData에 추가
  //     if (customerId !== "") {
  //       displayData.customer = customerId;
  //     }
  //     // 1. 먼저 새 디스플레이 ID를 생성
  //     const newDisplayId = await createDisplayOnServer(isLoggedIn);

  //     if (!newDisplayId) {
  //       throw new Error("디스플레이 ID 생성에 실패했습니다.");
  //     }

  //     // 2. 생성된 ID에 디스플레이 정보를 업데이트
  //     await updateDisplayOnServer(newDisplayId, displayData);

  //     // 3. 디스플레이 목록 새로고침
  //     await fetchContentList();
  //   } catch (error) {
  //     console.error("새 디스플레이 저장 실패:", error);
  //     throw error; // AutodisplaySelectedPopup에서 에러 처리하도록 전달
  //   }
  // };

  // const handleDomainKeyGenerate = async () => {
  //   try {
  //     const createDisplayId = await createDisplayOnServer(isLoggedIn);
  //     // 성공 시 후속 처리, 예를 들어 팝업을 닫거나 상태 업데이트
  //     const response = await updateDisplayOnServer(
  //       createDisplayId,
  //       addDisplayForm
  //     );

  //     // 도메인 키 생성 성공 후 데이터 다시 불러오기
  //     await fetchContentList();
  //   } catch (error) {
  //     console.error("도메인 키 생성 오류:", error);
  //     // 실패 시 에러 처리
  //   } finally {
  //     setIsCustomizePopupOpen(false);
  //     handleCustomizePopupClose();
  //   }
  // };

  // 사이즈 계산 로직
  useEffect(() => {
    const { deviceDPI, deviceInch } = addDisplayForm.deviceSpec;

    if (!deviceDPI || !deviceInch) return;

    try {
      const resolutionMatch = deviceDPI.match(/(\d{3,})\s*[×x*]\s*(\d{3,})/);
      const inchMatch = deviceInch.match(/(\d+(\.\d+)?)/);

      if (!resolutionMatch || !inchMatch) return;

      const widthPx = parseInt(resolutionMatch[1], 10);
      const heightPx = parseInt(resolutionMatch[2], 10);
      const diagonalInch = parseFloat(inchMatch[1]);

      const aspectRatio = widthPx / heightPx;
      const heightInch = diagonalInch / Math.sqrt(aspectRatio ** 2 + 1);
      const widthInch = heightInch * aspectRatio;

      const widthMm = Math.round(widthInch * 25.4);
      const heightMm = Math.round(heightInch * 25.4);

      setAddDisplayForm((prev) => ({
        ...prev,
        deviceSpec: {
          ...prev.deviceSpec,
          deviceWidth: widthPx.toString(),
          deviceHeight: heightPx.toString(),
          deviceWidthMM: widthMm.toString(),
          deviceHeightMM: heightMm.toString(),
        },
      }));
    } catch (e) {
      console.error("Failed to calculate display size", e);
    }
  }, [
    addDisplayForm.deviceSpec.deviceDPI,
    addDisplayForm.deviceSpec.deviceInch,
  ]);

  const handleCreateContentPopup = () => {
    setShowDeviceSelectPopup(true);
  };

  // 새 콘텐츠 버튼 클릭 시 콘텐츠 유형 선택 팝업 표시
  const handleNewContentClick = () => {
    setShowContentTypePopup(true);
  };

  // 콘텐츠 유형 선택 팝업 닫기
  const handleContentTypePopupClose = () => {
    setShowContentTypePopup(false);
  };

  // 일반 콘텐츠 선택
  const handleSelectGeneralContent = () => {
    setShowContentTypePopup(false);
    if (onCreateGeneralContent) {
      onCreateGeneralContent();
    }
  };

  // 급식 콘텐츠 선택
  const handleSelectMealContent = () => {
    setShowContentTypePopup(false);
    if (onCreateMealContent) {
      onCreateMealContent();
    }
  };

  const handleEditDisplayPopup = (displayId) => {
    setShowDeviceSelectPopup(true);
    setSelectedEditDisplayId(displayId);
  };

  return (
    <DashboardContainer>
      <MoleculeHeader />

      {/* 메인 컨텐츠 */}
      <MainContent>
        {/* 상단 섹션 */}
        <TopSection>
          <CompanyInfo>
            {/* <Avatar /> */}
            <CompanyName>
              {companyName.includes("학년 주임")
                ? companyName[0] + "학년"
                : companyName}{" "}
              콘텐츠 제작
            </CompanyName>
          </CompanyInfo>
          <ButtonGroup>
            <StyledContentButton onClick={onBack}>
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ flexShrink: 0 }}
              >
                <circle
                  cx="10.11"
                  cy="10.11"
                  r="7.11"
                  stroke="#256EF4"
                  strokeWidth="1.5"
                />
                <line
                  x1="9.89549"
                  y1="6.4099"
                  x2="9.89549"
                  y2="10.1839"
                  stroke="#256EF4"
                  strokeWidth="1.86911"
                  strokeLinecap="round"
                />
                <line
                  x1="11.8236"
                  y1="11.5456"
                  x2="9.92994"
                  y2="10.1967"
                  stroke="#256EF4"
                  strokeWidth="1.86911"
                  strokeLinecap="round"
                />
              </svg>
              <Sub2 color="primary">콘텐츠 편성</Sub2>
            </StyledContentButton>
            <Button
              Large
              Primary
              Fill
              onClick={handleNewContentClick}
              style={{ display: "inline-flex", alignItems: "center" }}
            >
              <svg
                width={20}
                height={20}
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ flexShrink: 0 }}
              >
                <path
                  d="M9.99935 4.16669V15.8334M4.16602 10H15.8327"
                  stroke="white"
                  strokeWidth={2}
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
              <Sub2 color="white" style={{ marginLeft: "0px" }}>
                새 콘텐츠
              </Sub2>
            </Button>
          </ButtonGroup>
        </TopSection>

        {/* 콘텐츠 현황 섹션 */}
        {/* <StatsSection>
          <SectionTitle>콘텐츠 및 디스플레이 현황</SectionTitle>
          <StatsGrid>
            <StatCard>
              <StatHeader>
                <Body2 color="gray600">총 생성된 콘텐츠 수 </Body2>
              </StatHeader>
              <StatValue>{contentList.length} 건</StatValue>
            </StatCard>
            <StatCard>
              <StatHeader>
                <Body2 color="gray600">활성화 중 디스플레이 수 </Body2>
              </StatHeader>
              <StatValue>{activateCount ? activateCount : 0} 건</StatValue>
            </StatCard>
            <StatCard>
              <StatHeader>
                <Body2 color="gray600">디스플레이 정보</Body2>
              </StatHeader>
              <DisplayInfoContent>
                {displayList.length > 0 ? (
                  <>
                    <DisplayInfoText>86인치 UHD | 3840 × 2160</DisplayInfoText>
                  </>
                ) : (
                  <DisplayInfoText>
                    등록된 디스플레이가 없습니다
                  </DisplayInfoText>
                )}
              </DisplayInfoContent>
            </StatCard>
          </StatsGrid>
        </StatsSection> */}
        {/* 탭 및 테이블 섹션 */}

        <TableSection>
          <TabContainer>
            <TabWrapType3>
              <SectionTitle>
                제작 완료 콘텐츠 ({contentList.length}건)
              </SectionTitle>
            </TabWrapType3>

            {/* <CustomPopupSubtitle>
              콘텐츠 연결 주소:{" "}
              <ContentLink
                href={`${window.location.origin}/autodisplayViewEdu`}
                target="_blank"
                rel="noopener noreferrer"
              >
                autodisplayViewEdu
              </ContentLink>
            </CustomPopupSubtitle> */}
          </TabContainer>

          <OrganismEduDashboardContentList
            handleCreateContent={onCreateContent}
          />
        </TableSection>
      </MainContent>

      {/* 콘텐츠 유형 선택 팝업 */}
      {showContentTypePopup && (
        <MoleculeContentTypeSelectPopup
          onClose={handleContentTypePopupClose}
          onSelectGeneral={handleSelectGeneralContent}
          onSelectMeal={handleSelectMealContent}
        />
      )}
      {/* <Card>
        <CardImg>
          <img
            src={class_one_img}
            alt="1학년 2반'"
            style={{ width: "320px", height: "157px", objectFit: "contain" }}
          />
        </CardImg>
        <CardContent>
          <CardTitle>1학년 2반</CardTitle>
          <CardArrangement>
            <CardDesc>
              우리 반 소식과 일정을 콘텐츠로 생성하고 원하는 시간에 편성하세요.
            </CardDesc>
            <ButtonArrow onClick={onCreateContent}>
              <img src={arrow_svg} alt="arrow" />
              <span>이동</span>
            </ButtonArrow>
          </CardArrangement>
        </CardContent>
      </Card>
      <Card>
        <CardImg>
          <img
            src={class_all_img}
            alt="1학년 전체'"
            style={{ width: "320px", height: "157px", objectFit: "contain" }}
          />
        </CardImg>
        <CardContent>
          <CardTitle>1학년 전체</CardTitle>
          <CardArrangement>
            <CardDesc>
              학년 전체 대상 공지와 일정을 콘텐츠로 생성하고 원하는 시간에
              편성하세요.
            </CardDesc>
            <ButtonArrow onClick={onCreateContent}>
              <img src={arrow_svg} alt="arrow" />
              <span>이동</span>
            </ButtonArrow>
          </CardArrangement>
        </CardContent>
      </Card> */}

      {/* 기기 없음 알림 팝업 */}

      {/* 기기 선택 팝업 */}
      {/* {showDeviceSelectPopup && (
        <AutodisplaySelectedPopup
          onClose={handleAutoDisplayClose}
          onSelect={handleAutoDisplaySelect}
          onSaveNewDisplay={handleSaveNewDisplay}
          selectedEditDisplayId={selectedEditDisplayId}
        />
      )} */}

      {/* {showConfirmPopup && (
        <PopupWrap
          Warning
          title="정말 활성화 하시겠습니까?"
          // message={
          //   <>
          //     보유한 크레딧이 부족합니다.
          //     <br />
          //     크레딧을 충전한 후 다시 시도해주세요.
          //   </>
          // }
          buttonType="Outline"
          closeText="취소"
          confirmText="확인"
          isModal={false}
          onCancel={() => {
            setShowConfirmPopup(false);
          }}
          onConfirm={() => {
            setShowConfirmPopup(false);
            handleDomainKeyGenerate();
          }}
        />
      )} */}
    </DashboardContainer>
  );
};

export default TemplateEducationContentsList;

export function MoveButton({ onClick }) {
  return (
    <ButtonArrow onClick={onClick}>
      <img src={arrow_svg} alt="arrow" />
      <span>이동</span>
    </ButtonArrow>
  );
}

// PopupContent 스타일 추가
const PopupContent = styled.div`
  margin-top: 8px;
`;

// 스타일 컴포넌트들
const DashboardContainer = styled.div`
  width: 100%;
  max-width: 2330px;
  margin: 0 auto;
  background: ${palette.white};
  min-height: 100vh;
`;

const Header = styled.header`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 40px;
  height: 56px;
`;

const Logo = styled.h1`
  font-family: Poppins;
  font-weight: 700;
  font-size: 20px;
  color: #323232;
  margin: 0;
`;

const HeaderRight = styled.div`
  display: flex;
  align-items: center;
  gap: 24px;
`;

const CreditSection = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CreditIcon = styled.div`
  width: 20px;
  height: 20px;
  background: #ffd54a;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
`;

const CreditText = styled.span`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 14px;
  color: #323232;
`;

const CreditArrow = styled.span`
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #cccccc;
`;

const NotificationIcon = styled.div`
  width: 18px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const MoreIcon = styled.div`
  width: 18px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Divider = styled.div`
  width: 100%;
  height: 1px;
  background: #e0e4eb;
`;

const MainContent = styled.main`
  max-width: 1240px;
  margin: 0 auto;
  padding: 145px 0;
  display: flex;
  flex-direction: column;
  gap: 72px;
`;

const TopSection = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

const CompanyInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Avatar = styled.div`
  width: 48px;
  height: 48px;
  background: #d9d9d9;
  border-radius: 50%;
  background-image: url("/logo192.png");
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`;

const CompanyName = styled.h2`
  font-family: poppins;
  font-weight: 700;
  font-size: 32px;
  color: #1e2124;
  margin: 0;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 20px;
`;

const StatsSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const SectionTitle = styled.h3`
  font-family: Pretendard;
  font-weight: 700;

  font-size: 16px;
  color: #696969;
  margin: 0;
  text-align: left;
`;

const StatsGrid = styled.div`
  display: flex;
  gap: 20px;
`;

const StatCard = styled.div`
  flex: 1;
  background: ${palette.white};
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const StatHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StatValue = styled.div`
  font-family: Poppins;
  font-weight: 700;

  font-size: 30px;
  color: #666666;
  text-align: left;
`;

const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const TabContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 100%;
`;

const TabGroup = styled.div`
  display: flex;
  gap: 8px;
`;

const Tab = styled.button`
  padding: 8px 10px;
  border-radius: 8px;
  border: 1px solid ${({ active }) => (active ? "#E0E4EB" : "#e0e4eb")};
  background: ${({ active }) => (active ? "#F7F8FA" : "transparent")};
  color: ${palette.gray700};
  font-weight: ${({ active }) => (active ? 600 : 400)};
  font-size: 15px;
  cursor: pointer;
  margin-right: 8px;
  transition: background 0.2s, color 0.2s, border 0.2s;

  &:last-child {
    margin-right: 0;
  }
`;

const Table = styled.div`
  border-radius: 0;
  overflow: hidden;
`;

const TableHeader = styled.div`
  display: flex;
  background: #eef2f7;
`;

const TableBody = styled.div`
  display: flex;
  flex-direction: column;
`;

const TableRow = styled.div`
  display: flex;
  background: ${palette.white};

  &:not(:last-child) {
    border-bottom: 1px solid #cdd1d5;
  }
`;

const HeaderCell = styled.div`
  padding: 20px 16px;
  font-family: Pretendard;
  font-weight: 700;
  font-size: 15px;
  color: #131416;
  border-right: 1px solid #d6e0eb;

  ${(props) =>
    props.wide
      ? `
    flex: 1;
    text-align: left;
  `
      : `
    width: 240px;
    text-align: right;
  `}

  &:last-child {
    border-right: none;
  }
`;

const TableCell = styled.div`
  padding: 20px 16px;
  font-family: Pretendard;
  font-weight: 400;
  font-size: 17px;
  color: #464c53;
  border-right: 1px solid #cdd1d5;

  ${(props) =>
    props.wide
      ? `
    flex: 1;
    text-align: left;
  `
      : `
    width: 240px;
    text-align: right;
  `}

  &:last-child {
    border-right: none;
  }
`;

const PopupFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 0;
`;

const FormField = styled.div`
  display: flex;
  flex-direction: column;
  // gap: 4px;
  flex: ${(props) => props.flex || "none"};
  margin-bottom: -10px;

  Body2 {
    margin-bottom: 10px;
  }
`;

const FormRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SizeInputRow = styled.div`
  display: flex;
  gap: 16px;
`;

const SizeInputGroup = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  gap: 8px;
`;

const SizeInput = styled.input`
  flex: 1;
  padding: 16px;
  border: 1px solid #e0e4eb;
  border-radius: 10px;
  font-size: 1rem;
  color: ${palette.gray700};

  &:focus {
    outline: none;
    border-color: ${palette.primary};
  }

  &::placeholder {
    color: ${palette.gray500};
  }
`;

const SizeUnit = styled.span`
  font-size: 14px;
  color: ${palette.gray600};
  min-width: 24px;
`;

const ButtonCenter = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

const InfoBox = styled.div`
  background-color: ${palette.primaryLightest};
  border-radius: 8px;
  padding: 16px;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  // gap: 16px;
`;

const LargeButton = styled(Button)`
  width: 200px;
  padding: 16px 32px;
  font-size: 16px;
  min-height: 56px;
`;

const DirectInputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 8px;
`;

const ResetButton = styled.button`
  background: none;
  border: none;
  color: ${palette.gray400};
  cursor: pointer;
  padding: 8px;
  border-radius: 4px;

  &:hover {
    background-color: ${palette.gray100};
    color: ${palette.gray700};
  }
`;

const ContentLink = styled.a`
  color: ${palette.primary};
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    color: ${palette.primary}DD;
    text-decoration: underline;
  }

  &:visited {
    color: ${palette.primary};
  }
`;

const CustomPopupSubtitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${palette.gray600};
  margin: 0;
  margin-bottom: 12px;
`;

const StatCardContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DisplayInfoContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`;

const DisplayInfoText = styled.div`
  font-family: Pretendard;
  font-weight: 500;
  font-size: 24px;
  color: #666666;
  font-weight: 700;
  text-align: left;
  line-height: 1.8;
`;

const Card = styled.div`
  width: 320px;
  min-height: 320px;
  background: #fff;
  border-radius: 18px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
  padding: 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  cursor: pointer;
  transition: box-shadow 0.2s ease;

  &:hover {
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07), 0 0 0 1.5px #256ef4;
  }
`;

const CardImg = styled.div`
  width: 100%;
  height: 157px;
  object-fit: contain;
`;

const CardArrangement = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  width: 100%;
  height: 100%;
`;

const CardContent = styled.div`
  width: 100%;
  height: 163px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 20px;
`;

const CardTitle = styled(Body3)`
  font-size: 20px;
  font-weight: 700;
  color: #323232;
  margin-bottom: 8px;
  text-align: center;
`;

const CardDesc = styled(Body2)`
  color: #464c53;
  font-size: 15px;
  text-align: center;
  margin-bottom: 8px;
  flex-grow: 1;
`;

const ButtonArrow = styled.button`
  background: transparent;
  border: 1px solid #256ef4;
  border-radius: 50%;
  box-sizing: border-box; /* border 두께까지 포함해서 계산 */
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  width: 34px;
  height: 34px;
  min-width: 34px;
  min-height: 34px;
  overflow: hidden;

  transition: width 0.2s, padding 0.2s, box-shadow 0.2s, border-radius 0.2s,
    opacity 0.2s;

  svg,
  img {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    transition: transform 0.2s;
  }

  span {
    display: none;
    margin-left: 6px;
    font-size: 16px;
    font-family: Pretendard, sans-serif;
    font-weight: 700;
    color: #256ef4;
    white-space: nowrap;
    transition: opacity 0.2s;
  }

  &:hover {
    width: auto;
    padding: 5px 15px;
    border-radius: 17px;

    box-shadow: 0 0 0 1px #256ef4;

    border: none;
  }
  &:hover svg,
  &:hover img {
    transform: translateX(0);
  }
  &:hover span {
    display: inline-block;
    color: #256ef4;
    font-size: 16px;
    font-family: Pretendard, sans-serif;
    font-weight: 700;
    line-height: 24px;
    opacity: 1;
  }
`;

const StyledContentButton = styled(Button).attrs({
  Large: true,
  PrimaryLightest: true,
  Fill: true,
})`
  display: inline-flex;
  align-items: center;
  gap: 8px;

  &:hover {
    background: #e6f0ff !important;
  }
`;
